import {
  CrossList,
  H5,
  Link,
  Message,
  MessageVariants,
  P,
  ProminenceVariants,
  Text,
  TickList,
} from "@nel-ui/react";

import { MESSAGE_HEADING_TYPE, MESSAGE_TYPE } from "../../constants";
import { IBlockInformationProps, IListItems } from "../../interfaces";

import "./style.css";

const mainClass = "block-info";
const BlockInformation: React.FC<IBlockInformationProps> = (
  props: IBlockInformationProps
) => {
  const { howBlockWorks, howToBlockAccess, showGamCareLink, whatDoWeBlock } =
    props;

  return (
    <>
      <H5
        as="h3"
        className={`${mainClass}__heading`}
        data-testid={`${mainClass}-heading`}
      >
        {whatDoWeBlock?.heading}
      </H5>
      <Text
        className={`${mainClass}__sub-heading`}
        data-testid={`${mainClass}-subHeading`}
        variant="strong"
      >
        {whatDoWeBlock?.block_transaction_companies?.heading}
      </Text>
      <TickList className={`${mainClass}__list-items`}>
        {whatDoWeBlock?.block_transaction_companies?.tickListItems?.map(
          (item: IListItems) => (
            <TickList.Item key={item.id}>{item.text}</TickList.Item>
          )
        )}
      </TickList>
      <Text
        className={`${mainClass}__sub-heading`}
        data-testid={`${mainClass}-can-not-subHeading`}
        variant="strong"
      >
        {whatDoWeBlock?.cannot_be_blocked?.heading}
      </Text>
      <CrossList className={`${mainClass}__list-items`}>
        {whatDoWeBlock?.cannot_be_blocked?.crossListItems?.map(
          (item: IListItems) => (
            <CrossList.Item key={item.id}>{item.text}</CrossList.Item>
          )
        )}
      </CrossList>
      <Message
        data-ref={MESSAGE_TYPE.INFO}
        heading={MESSAGE_HEADING_TYPE.INFORMATION}
        headingId={MESSAGE_TYPE.INFO}
        headingLevel={3}
        prominence={ProminenceVariants.HIGH}
        variant={MessageVariants.INFO}
      >
        <P data-testid={`${mainClass}-info-message`}>
          {howBlockWorks?.additional_block_info}
          <Link href={howBlockWorks?.block_info_url} target="_blank">
            {howBlockWorks?.block_info_text}
          </Link>
        </P>
      </Message>
      {showGamCareLink && (
        <div
          className={`${mainClass}__gamcare-link`}
          data-testid={`${mainClass}-gamcare-link`}
        >
          <Link href={howToBlockAccess?.url} target="_blank">
            {howToBlockAccess?.text}
          </Link>
        </div>
      )}
    </>
  );
};

export default BlockInformation;
